module.exports = __webpack_public_path__ + "img/hr-heated-straight-vertical-5.c82f27b6.png";